import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'my-account-greeting',
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss']
})
export class GreetingComponent implements OnInit {
  name = '';

  constructor(private readonly userService: UserService) {}

  ngOnInit(): void {
    this.userService
      .getUser()
      .pipe(take(1))
      .subscribe({
        next: (user: IUser) => (this.name = user?.firstName)
      });
  }
}
